import { render, staticRenderFns } from "./CampaignProfile.vue?vue&type=template&id=1c416304&scoped=true"
import script from "./CampaignProfile.vue?vue&type=script&lang=js"
export * from "./CampaignProfile.vue?vue&type=script&lang=js"
import style0 from "./CampaignProfile.vue?vue&type=style&index=0&id=1c416304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c416304",
  null
  
)

export default component.exports